import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    levelName: '',
    loading: false,
}

const NewClassLevel = () => {

    const [currentNotify, setNotify] = useState(null);
    const {getClassLevels} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }
        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.createClassLevel(state.levelName);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'RESET'});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            setTimeout(() => {
                getClassLevels(true);
            }, 5000);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }

  

    return (
        <div className="card-body">

            <CallOut 
                title="New Class Level"
                description="E.g. Ordinary level, Advanced level, etc."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Level Name"
                            placeholder="Level Name"
                            leftIcon="fa fa-bookmark"
                            value={state.levelName}
                            onChange={e => dispatch({type: 'levelName', value: e.target.value})}
                            required
                            wrap
                            />

                
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Level</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewClassLevel;